import React from "react";
import LegacyQRCode from "./LegacyQRCode";
import ProductBarcodeLabel from "../ProductBarcodeLabel";
import { USE_LEGACY_PRODUCT_QR_LABELS } from "../../../config/productLabels";

export default function ProductLabel(props) {
  return USE_LEGACY_PRODUCT_QR_LABELS
    ? <LegacyQRCode {...props} />
    : <ProductBarcodeLabel {...props} />;
}
